import { render, staticRenderFns } from "./HireDetails.vue?vue&type=template&id=e1a721d0"
import script from "./HireDetails.vue?vue&type=script&lang=js"
export * from "./HireDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports